import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import MaybeCancellationAndRefundPolicies from './MaybeCancellationAndRefundPolicies';
import TermsOfService from './TermsOfService';
import { useMerchantTermsOfServiceMessage } from '../../hooks/useMerchantTermsOfServiceMessage';
import MaybeFutureChargesTotals from '../FutureCharges/MaybeFutureChargesTotals';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TermsOfServiceMessages = ({
  policySettings,
  shouldDisplayPMOFMessage,
  shouldShowFutureChargesMessage,
  isZeroCheckout
}) => {
  const translationMessageKey = useMerchantTermsOfServiceMessage();
  const TermsOfServiceMessagesContent = useMemo(() => {
    if (shouldShowFutureChargesMessage) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.futureChargesDisclaimer.message"
        }), ' ', /*#__PURE__*/_jsx(MaybeFutureChargesTotals, {
          shouldApplyStyling: false
        })]
      });
    }
    if (shouldDisplayPMOFMessage) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.paymentMethodOnFile.message"
        }), ' ', /*#__PURE__*/_jsx(MaybeFutureChargesTotals, {
          shouldApplyStyling: false
        })]
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(TermsOfService, {
          translationMessageKey: translationMessageKey,
          isZeroCheckout: isZeroCheckout
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        children: policySettings && /*#__PURE__*/_jsx(MaybeCancellationAndRefundPolicies, {
          policySettings: policySettings
        })
      })]
    });
  }, [shouldShowFutureChargesMessage, shouldDisplayPMOFMessage, policySettings, translationMessageKey, isZeroCheckout]);
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "terms-of-service-messages",
    children: [TermsOfServiceMessagesContent, /*#__PURE__*/_jsx(HR, {})]
  });
};
export default TermsOfServiceMessages;